import { Injectable, inject } from '@angular/core';
import { VacationWidget } from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  HeaderFooterMachCore,
  SearchOrgDestResponse
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  AirportDropDown,
  DestinationType
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  CitiesDetails,
  FilterCitiesUtilService,
  FilterOriginDestDetails
} from '@com-delta-idp/mnx-sitewide-shared-utils';
import { SearchItem } from '@com-delta-omnichannel/mach-core-js';
import {
  processAirportData,
  validateAEM
} from '../../utils/booking-vacation/booking-vacation.utils';
import { AirportTransformerService } from './airport-transformer.service';
import { BookingVacationBaseAdapterService } from './booking-vacation-base-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class BookingVacationAdapterService extends BookingVacationBaseAdapterService {
  private transformerService = inject(AirportTransformerService);
  private filterCitiesUtilService = inject(FilterCitiesUtilService);
  originListSearchItem: SearchItem[] = [];
  destinationListSearchItem: SearchItem[] = [];
  originAirportData: CitiesDetails[] = [];
  destinationAirportList: CitiesDetails[] = [];
  bookingWidgetAem!: HeaderFooterMachCore;

  getContent(aem: HeaderFooterMachCore): VacationWidget {
    if (!validateAEM(aem)) {
      throw new Error('Invalid AEM structure: vacations object is missing');
    }
    this.errorBannerMessage =
      aem.header?.book.vacations.error?.errorBannerMessage || '';
    this.bookingWidgetAem = aem;
    return {
      fromAndToOption: this.getFromAndToOptions(aem),
      dropDownPassengerOption: this.getPassengerOptions(aem),
      dropDownRoomOption: this.getRoomOptions(aem),
      dropDownDateOption: this.getDateOptions(aem),
      labels: aem.header?.book?.vacations.labels,
      accessibility: aem.header?.book?.vacations.accessibility,
      certificatesLink: { url: '' }
    };
  }

  transformModalContent(
    originDestData: FilterOriginDestDetails,
    searchTerm: string,
    destinationType: DestinationType,
    selectedCode = ''
  ): AirportDropDown {
    const result =
      this.filterCitiesUtilService.filterOriginDestCitiesList(originDestData);
    return this.transformerService.transformToModalContent(
      result,
      searchTerm,
      this.bookingWidgetAem,
      destinationType,
      selectedCode
    );
  }

  setAirportListArray(
    content: [SearchOrgDestResponse, SearchOrgDestResponse]
  ): void {
    const [origin, destination] = content;
    const originCities = processAirportData(origin);
    const destinationCities = processAirportData(destination);

    this.originAirportData = originCities;
    this.destinationAirportList = destinationCities;
    this.originListSearchItem =
      this.transformerService.transformCitiesToAirportList(originCities);
    this.destinationListSearchItem =
      this.transformerService.transformCitiesToAirportList(destinationCities);
  }
}
